import { authMiddleware } from "@/middleware";
import { createFileRoute } from "@tanstack/react-router";

import { DashboardLayout } from "@/components";
import { SettingsPage } from "@/pages/settings";

export const Route = createFileRoute("/_market/settings/")({
	component: () => (
		<DashboardLayout>
			<SettingsPage />
		</DashboardLayout>
	),
	loader: authMiddleware,
});
